import React from 'react';
import classNames from 'classnames';
import { Tag as AntdTag } from 'antd';
import warning from 'antd/es/_util/warning';
import { ConfigContext } from '../config-provider';
import { PresetColorTypes, PresetStatusColorTypes } from '../_util/colors';
import CheckableTag from './CheckableTag';
import { Icon } from '../icon';
const PresetStatusColorRegex = new RegExp(`^(${PresetStatusColorTypes.join('|')})$`);
const PresetColorRegex = new RegExp(`^(${PresetColorTypes.join('|')})(-inverse)?$`);
const InternalTag = (props, ref) => {
    const { prefixCls, size, className, closeIcon, rounded, color, ...otherProps } = props;
    const { closable, disabled = 'false', type } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const classPrefix = getPrefixCls('tag', prefixCls);
    const newCloseIcon = closeIcon ? closeIcon : React.createElement(Icon, { type: 'close' });
    if (process.env.NODE_ENV !== 'production')
        warning(!('theme' in props), 'Tag', '`theme` is depreacted in B-Design 3.0');
    let tagColor = !color ? '' : color.toLocaleLowerCase().replace(/\s/g, '-');
    const isPresetColor = () => {
        if (!color) {
            return false;
        }
        return PresetColorRegex.test(tagColor) || PresetStatusColorRegex.test(tagColor) || tagColor === 'white';
    };
    const presetColor = isPresetColor();
    const newClassName = classNames(className, {
        [`${classPrefix}-xs`]: size === 'xs',
        [`${classPrefix}-sm`]: size === 'small',
        [`${classPrefix}-lg`]: size === 'large',
        [`${classPrefix}-closeable`]: closable,
        [`${classPrefix}-disabled`]: disabled === true,
        [`${classPrefix}-has-color`]: color && !presetColor,
        [`${classPrefix}-${tagColor}`]: presetColor,
        [`${classPrefix}-outline`]: type === 'outline' && presetColor,
        [`${classPrefix}-solid`]: type === 'solid' && presetColor,
        [`${classPrefix}-rounded`]: rounded
    });
    return (React.createElement(AntdTag, { className: newClassName, closeIcon: newCloseIcon, color: !presetColor ? tagColor : '', ref: ref, ...otherProps, prefixCls: classPrefix }));
};
const Tag = React.forwardRef(InternalTag);
Tag.displayName = 'Tag';
Tag.CheckableTag = CheckableTag;
export { Tag };
export default Tag;
